export const endpoints = {
  auth: {
    me: '/api/auth/me',
    login: '/api/public/login',
    register: '/api/public/register',
    logout: '/api/refresh-token/logout',
    sendForgotPasswordEmail: '/api/public/forgot-password',
    refreshToken: '/api/refresh-token',
  },
  jobRole: {
    getAll: '/api/auth/job-roles',
    getById: (id: string) => `/api/auth/job-roles/${id}`,
    create: '/api/auth/job-roles',
    edit: (jobRoleId: string) => `/api/auth/job-roles/${jobRoleId}`,
    delete: (jobRoleId: string) => `/api/auth/job-roles/${jobRoleId}`,
    addSkill:(jobRoleId:string, skillId:string) => `/api/auth/job-roles/${jobRoleId}/skills/${skillId}`,
    removeSkill:(jobRoleId:string, skillId:string) => `/api/auth/job-roles/${jobRoleId}/skills/${skillId}`,
    getUsers: (jobRoleId: string) => `/api/auth/job-roles/${jobRoleId}/users`,
    getStats: (jobRoleId: string) => `/api/auth/job-roles/${jobRoleId}/stats`,
  },
  skill: {
    getSkillsWithBasicData: '/api/auth/skills',
    getById: (skillId: string) => `/api/auth/skills/${skillId}`,
    create: '/api/admin/skills',
    edit: (skillId: string) => `/api/admin/skills/${skillId}`,
    delete: (skillId: string) => `/api/admin/skills/${skillId}`,
    duplicate: (skillId: string) => `/api/admin/skills/${skillId}/duplicate`,
    addTopic: (skillId: string) => `/api/admin/skills/${skillId}/topics`,
    updateTopic: (skillId: string, topicId: string) =>
      `/api/admin/skills/${skillId}/topics/${topicId}`,
    deleteTopic: (skillId: string, topicId: string) =>
      `/api/admin/skills/${skillId}/topics/${topicId}`,
    reorderTopics: (skillId: string) => `/api/admin/skills/${skillId}/topics/reorder`,
    addSubTopic: (skillId: string, topicId: string) =>
      `/api/admin/skills/${skillId}/topics/${topicId}/subtopics`,
    updateSubTopic: (skillId: string, topicId: string, subId: string) =>
      `/api/admin/skills/${skillId}/topics/${topicId}/subtopics/${subId}`,
    deleteSubTopic: (skillId: string, topicId: string, subId: string) =>
      `/api/admin/skills/${skillId}/topics/${topicId}/subtopics/${subId}`,
    reorderSubTopics: (skillId: string, topicId: string) =>
      `/api/admin/skills/${skillId}/topics/${topicId}/subtopics/reorder`,
    addTopicResource: (skillId: string, topicId: string) =>
      `/api/admin/skills/${skillId}/topics/${topicId}/resources`,
    updateTopicResource: (skillId: string, topicId: string, resourceId: string) =>
      `/api/admin/skills/${skillId}/topics/${topicId}/resources/${resourceId}`,
    deleteTopicResource: (skillId: string, topicId: string, resourceId: string) =>
      `/api/admin/skills/${skillId}/topics/${topicId}/resources/${resourceId}`,
    addSubTopicResource: (skillId: string, topicId: string, subId: string) =>
      `/api/admin/skills/${skillId}/topics/${topicId}/subtopics/${subId}/resources`,
    updateSubTopicResource: (skillId: string, topicId: string, subId: string, resourceId: string) =>
      `/api/admin/skills/${skillId}/topics/${topicId}/subtopics/${subId}/resources/${resourceId}`,
    deleteSubTopicResource: (skillId: string, topicId: string, subId: string, resourceId: string) =>
      `/api/admin/skills/${skillId}/topics/${topicId}/subtopics/${subId}/resources/${resourceId}`,
  },
  evaluation: {
    update: '/api/auth/evaluations/update',
    getMyEvaluations: '/api/auth/evaluations/me',
    getUserEvaluations: (userId: string) => `/api/auth/evaluations/user/${userId}`,
    getLeaderboard: (skillId: string) => `/api/auth/evaluations/leaderboard/${skillId}`,
    reset: (skillId: string) => `/api/auth/evaluations/${skillId}/reset`,
  },
  user: {
    addUser: '/api/auth/user/create-user',
    editUser: '/api/auth/user/edit-user',
    deleteUser: '/api/auth/user/delete-user',
    getUsersByOrganization: '/api/auth/user/get-users-by-organization',
    getUsers: '/api/public/user/get-user',
    getAllUsers: '/api/admin/user/get-all-users',
    updatePassword: '/api/auth/me/update-password',
    setPassword: '/api/public/set-password',
    getAllSuperAdmins: '/api/auth/user/get-all-super-admins',
    resendInvitation: '/api/auth/user/resend-invitation',
    updateRole: (userId: string) => `/api/auth/user/${userId}/role`,
    updateJobRoles: (userId: string) => `/api/auth/user/${userId}/job-roles`,
    getMyDashboard: '/api/auth/user/me/dashboard',
  },
  tag: {
    getTagsByOrganization: (id: string) => `/api/auth/tag/get-tags-by-organization/${id}`,
    addNew: '/api/auth/tag/create-tag',
    edit: '/api/auth/tag/edit-tag',
    delete: (id: string) => `/api/auth/tag/delete-tag/${id}`,
  },
  organization: {
    getOrganization: '/api/auth/get-organization',
    getAllOrganizations: '/api/auth/get-all-organizations',
    deleteOrganization: '/api/super-admin/delete-organization',
    editOrganization: '/api/auth/edit-organization',
    superAdminCreateOrganization: '/api/super-admin/create-organization',
    setOrganizationSuspension: (id: string) => `/api/super-admin/set-organization-suspension/${id}`,
    summeryOrganization: (organization: string) =>
      `/api/auth/get-organizations-summary/${organization}`,
  },
  upload: {
    uploadFile: '/api/auth/upload/upload-file',
    getFileById: (uploadId: string) => `/public/upload/get-upload/${uploadId}`,
    getThumbnailById: (uploadId: string) => `/public/upload/thumbnail/${uploadId}`,
    deleteFile: '/api/auth/upload/delete-upload',
  },
  search: {
    search: (organizationId: string) => `/api/auth/search/${organizationId}`,
  },
  notification: {
    getNotifications: '/api/auth/get-filtered-notifications',
    editNotification: '/api/auth/edit-notifications',
    resendNotification: '/api/auth/update-notification',
    broadcast: '/api/admin/notifications/broadcast',
    // clear:'/api/auth/notifications/clear'
  },
  subscription: {
    subscribe: (id: string) => `/api/auth/subscription/subscribe/${id}`,
    getSubscriptionPlans: '/api/public/subscription/subscription-plans',
    getSubscriptions: (id: string) => `/api/auth/subscription/${id}`,
    cancelSubscription: '/api/auth/subscription/cancel',
  },
  card: {
    getCardDetails: (id: string) => `/api/auth/card/fetch-payment-methods/${id}`,
    removeCardDetails: (id: string) => `/api/auth/card/remove-payment-method/${id}`,
  },
  common: {
    sendSupportEmail: `/api/public/common/send-support-email`,
    verifyRegistrationEmail: `/api/public/common/verify-email`,
  },
  paymentUser: {
    createPaymentUser: `/api/auth/payment-user/create-user`,
    getPaymentUser: (orgId: string) => `/api/auth/payment-user/get-user/${orgId}`,
  },
  analytics: {
    teamSkills: '/api/auth/analytics/team-skills',
    skillGaps: '/api/auth/analytics/skill-gaps',
    topSkills: '/api/auth/analytics/top-skills',
    userGrowth: '/api/auth/analytics/user-growth',
    evaluationActivity: '/api/auth/analytics/evaluation-activity',
    jobRoleCoverage: '/api/auth/analytics/job-role-coverage',
    orgSummary: '/api/auth/analytics/org-summary',
  },
  article: {
    getAll: '/api/auth/articles',
    getMine: '/api/auth/articles/mine',
    getById: (id: string) => `/api/auth/articles/${id}`,
    create: '/api/auth/articles/create',
    edit: '/api/auth/articles/edit',
    delete: (id: string) => `/api/auth/articles/delete/${id}`,
  },
  notificationPreferences: {
    get: '/api/auth/user/me/notification-preferences',
    update: '/api/auth/user/me/notification-preferences',
  },
};
